import { FormControl, FormGroup } from '@angular/forms';

import { FormType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    name: new FormControl(null),
    description: new FormControl(null),
    file: new FormControl(null),
  });
};
